import * as React from 'react';
import * as styles from "./TabBarPanel.css";
import { AppStore } from '../stores';
import { inject, observer } from 'mobx-react';
import { TabBarPanelItem } from './tabBarPanelItem/TabBarPanelItem';

export interface ITabBarPanelProps {
  store?: AppStore;
  selectPage: (index: number) => void;
}

@inject('store')
@observer
export class TabBarPanel extends React.Component<ITabBarPanelProps> {
  public render(): JSX.Element {
    let height = this.props.store.instance.settings.design.menuStyle === "TabBar" ? `calc(100vh - ${this.props.store.isIPhoneXType ? 160 : 120}px)` : `calc(100vh - ${window.platform === "android" ? 50 : this.props.store.isIPhoneXType ? 90 : 70}px)`;
    if (this.props.store.preview) {
      height = "600px";
    }
    const contentHeight = (Math.ceil((this.props.store.instance.settings.menu.length - 4) / 4) * 70) + 40;
    const menu = [];
    this.props.store.instance.settings.menu.forEach((page: any, index) => {
      if (index > 3 && page.components) {
        if (page.components[0] && page.components[0].type === "ExternalLink") {
          menu.push(
            <a
              href={page.components[0].url}
              target="_blank"
              data-interception="off"
              key={`tab_${index}`}
            >
              <TabBarPanelItem
                icon={page.icon}
                title={page.title}
                iconColor={this.props.store.selectedPageIndex === index ? this.props.store.instance.settings.design.tabBarHighlightColor : this.props.store.instance.settings.design.tabBarContentColor}
                titleColor={this.props.store.selectedPageIndex === index ? this.props.store.instance.settings.design.tabBarHighlightColor : this.props.store.instance.settings.design.tabBarContentColor}
                onClick={() => {
                  if (this.props.store.preview) {
                    this.props.store.selectedPageIndex = index;

                    if (this.props.selectPage) {
                      this.props.selectPage(index);
                    }
                  }
                }}
              />
            </a>
          );
        } else {
          menu.push(
            <TabBarPanelItem
              key={`tab_${index}`}
              icon={page.icon}
              title={page.title}
              iconColor={this.props.store.selectedPageIndex === index ? this.props.store.instance.settings.design.tabBarHighlightColor : this.props.store.instance.settings.design.tabBarContentColor}
              titleColor={this.props.store.selectedPageIndex === index ? this.props.store.instance.settings.design.tabBarHighlightColor : this.props.store.instance.settings.design.tabBarContentColor}
              onClick={() => {
                this.props.store.contentMapPageToShow = undefined;
                this.props.store.selectedPageIndex = index;
                if (this.props.selectPage) {
                  this.props.selectPage(index);
                }
                this.props.store.showMenu = false;
                document.getElementById("IA_contentArea").scrollTop = 0
                this.forceUpdate();
              }}
            />
          );
        }
      }
    });
    return (
      <div
        className={styles.IA_tabBarPanelPanel}
      >
        <div
          className={styles.IA_tabBarPanelPanelOverlay}
          onClick={() => this.props.store.showMenu = false}
          style={{
            height: height,
            visibility: this.props.store.showMenu ? "visible" : "hidden",
          }}
        />
        <div
          className={styles.IA_tabBarPanelPanelContent}
          style={{
            height: contentHeight,
            top: this.props.store.showMenu ? (this.props.store.preview ? (650 - (contentHeight + 50)) : `calc(100vh - ${contentHeight + (window.platform === "android" ? 100 : this.props.store.isIPhoneXType ? 160 : 120)}px)`) : (this.props.store.preview ? 650 : `100vh`),
            backgroundColor: this.props.store.instance.settings.design.tabBarColor,
            borderBottom: `1px solid ${this.props.store.instance.settings.design.tabBarContentColor}`
          }}
        >
          {menu}
        </div >
      </div >
    );
  }
}